// Importing necessary utilities and URLs
import { get, put } from "./httpClient"; // HTTP client for making GET and PUT requests
import {
  MERCHANT_SIGNUP_RESEND_MAIL,
  UPDATE_TEMPLETE_UNDER_PROVIDER_ID,
  GET_PRICING_TEMPLTE_DATA,
  GET_APPLICATION_TYPE_LIST,
  GET_PROCCERSOR_LIST,
  MERCHANT_INVITE_TEMPLETE_CALL,
} from "../Uintls/Urls"; // API endpoints

// Action to resend merchant signup email
export const sendMailAgain = (payload, successCallback, failureCallback) => async () => {
  try {
    const data = await get(MERCHANT_SIGNUP_RESEND_MAIL, payload);

    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to fetch pricing template data
export const getPricingTemplete = (successCallback, failureCallback, payload) => async () => {
  try {
    const data = await get(GET_PRICING_TEMPLTE_DATA, payload);

    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to fetch application type list
export const getApplicationType = (successCallback, failureCallback) => async () => {
  try {
    const data = await get(GET_APPLICATION_TYPE_LIST);

    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to fetch processor list
export const getProccesorList = (successCallback, failureCallback) => async () => {
  try {
    const data = await get(GET_PROCCERSOR_LIST);

    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to update pricing template
export const updatePricingTemplete = (payload, successCallback, failureCallback) => async () => {
  try {
    const data = await put(UPDATE_TEMPLETE_UNDER_PROVIDER_ID);

    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to fetch template fields details
export const templateFieldsDetailsCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const data = await get(MERCHANT_INVITE_TEMPLETE_CALL, payload);

    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};
